import './Card.css'

/**
 * Componente Card - Card reutilizável
 * 
 * @param {string} variant - Variante: 'default', 'elevated', 'outlined'
 * @param {boolean} hoverable - Se o card deve ter efeito hover
 * @param {boolean} clickable - Se o card é clicável (adiciona cursor pointer)
 * @param {function} onClick - Função de callback para clique
 * @param {string} className - Classes CSS adicionais
 * @param {React.ReactNode} children - Conteúdo do card
 */
function Card({
  variant = 'default',
  hoverable = false,
  clickable = false,
  onClick,
  className = '',
  children,
  ...props
}) {
  const baseClasses = [
    'card',
    `card-${variant}`,
    hoverable && 'card-hoverable',
    clickable && 'card-clickable',
    className
  ]
    .filter(Boolean)
    .join(' ')

  const Component = onClick || clickable ? 'div' : 'div'
  const role = onClick || clickable ? 'button' : undefined
  const tabIndex = onClick || clickable ? 0 : undefined

  const handleKeyDown = (e) => {
    if ((e.key === 'Enter' || e.key === ' ') && onClick) {
      e.preventDefault()
      onClick(e)
    }
  }

  return (
    <Component
      className={baseClasses}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      role={role}
      tabIndex={tabIndex}
      {...props}
    >
      {children}
    </Component>
  )
}

export default Card

